'use client'
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../utils/CONSTANTS';
import Header from '../components/header';



function PackingEntryView() {

  const { vnum } = useParams(); 
  

  useEffect(()=>{
    console.log(vnum);
    fetchPackageData(vnum)
    console.log(formData);
    setFormData({
      ...formData,vNo:vnum
    })
    
  },[])
  console.log(vnum);
  
  const [isMaximized, setIsMaximized] = useState(false);
  const [allCardNumbers, setAllCardNumbers] =   useState([]);
  const [perweight, setperweight] = useState()

  const [formData, setFormData] = useState({
    vNo: '',
    date: '',
    packerName: '',
    cardNo: '',
    qty: '',
    wt: '',
    packingQuantity: '',
    packingSize: '',
    remark: '',
    totalWt: '',
    pack: "",
  });


  const fetchPackageData = async (vno) => {
    if (vno) {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/package/getPackage/${vno}`, { withCredentials: true });
        const formattedDate = new Date(response.data.data.date).toISOString().split('T')[0];
        console.log(response.data.data);

        setFormData({
          date: formattedDate || '',
          packerName: response.data.data.packerName || '',
          cardNo: response.data.data.cardNo || '',
          qty: response.data.data.qty || '',
          wt: response.data.data.wt || '',
          packingQuantity: response.data.data.packingQuantity || '',
          packingSize: response.data.data.packingSize,
          remark: response.data.data.remark || '',
          pack: response.data.data.pack,
        });
        
       
      } catch (error) { console.error("Error fetching specific data:", error) };
    } else {
    }
  };







  return (
    <>
    <Header/>
    <div className="p-2 max-w-[700px] mx-auto bg-gray-100 text-sm">
      <div className="bg-white border border-gray-300 rounded shadow">
        <div className="flex items-center justify-between bg-gradient-to-r from-teal-600 to-teal-700 p-0.5">
          <span className="text-white font-semibold px-2">Packing Entry</span>
          <div className="flex gap-0.5">
            <button className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700">
              <span>−</span>
            </button>
            <button
              className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700"
              onClick={() => setIsMaximized(!isMaximized)}
            >
              <span>□</span>
            </button>
            <button className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700">
              <span>×</span>
            </button>
          </div>
        </div>

        <div className="p-2">
          <div className="mb-2">
            

            <div className="grid grid-cols-3 gap-2 bg-[#E0FFFF] p-2 rounded">
              <div>
                <label className="block mb-0.5">V. No.</label>
                <input
                  type="number"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="vno"
                  value={formData.vNo}
                  readOnly />
              </div>
              <div>
                <label className="block mb-0.5">Date</label>
                <input
                  type="date"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="date"
                  value={formData.date}
                  readOnly
                />
              </div>
              <div>
                <label className="block mb-0.5">Packer Name</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="qty"
                  value={formData.packerName}
                  readOnly />
              </div>
            </div>

            <div className="grid grid-cols-4 gap-2 mt-2">
              <div className="col-span-2">
                <label className="block mb-0.5">Card No.</label>
                <select
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="cardNo"
                  value={formData.cardNo}
                  disabled
                >
                  <option value="">Select Card No.</option>
                  {allCardNumbers.map((tool) => (
                    <option key={tool.cardNo} value={tool.cardNo}>{tool.cardNo}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block mb-0.5">Qty</label>
                <input
                  type="number"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="qty"
                  value={formData.qty}
                  readOnly />
              </div>
              <div>
                <label className="block mb-0.5">Wt.</label>
                <div className="flex gap-1">
                  <input
                    type="number"
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="wt"
                    value={formData.wt}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <label className="block mb-0.5">Packing Quantity</label>
                <div className="flex gap-1">
                  <input
                    type="number"
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="packingQuantity"
                    value={formData.packingQuantity}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <label className="block mb-0.5">Packing Weight</label>
                <div className="flex gap-1">
                  <input
                    type="number"
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="packingSize"
                    value={formData.packingSize}

                    readOnly
                  />

                </div>
              </div>
              <div>
                <label className="block mb-0.5">Pack</label>
                <div className="flex gap-1">
                  <input
                    type="number"
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="pack"
                    value={formData.pack}
                    readOnly
                  />

                </div>
              </div>
            </div>
          </div>


          <div className="bg-[#E0FFFF] p-2 rounded">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <label className="block mb-0.5">Remark</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="remark"
                  value={formData.remark}
                  disabled
                />
              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
    </>
  );
}

export default PackingEntryView;

